import { render, staticRenderFns } from "./ImportContact.vue?vue&type=template&id=8ef34ef4&scoped=true&"
import script from "./ImportContact.vue?vue&type=script&lang=js&"
export * from "./ImportContact.vue?vue&type=script&lang=js&"
import style0 from "./ImportContact.vue?vue&type=style&index=0&id=8ef34ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef34ef4",
  null
  
)

export default component.exports